import { render, staticRenderFns } from "./UploadedDocuments.vue?vue&type=template&id=62c0b60e&scoped=true&"
import script from "./UploadedDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadedDocuments.vue?vue&type=style&index=0&id=62c0b60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0b60e",
  null
  
)

export default component.exports